const params = new URLSearchParams(window.location.search);
console.log(params, '--11233')
const tg = params.get('ipet_tg');
const env = params.get('env');

console.log(tg, '--112343')
if (tg) {
  localStorage.setItem('ipet_tg', tg);
  localStorage.setItem('env', env);
}
console.log(customertime, '-------');
console.log(customerId, '----11111', tg)
if (customerId) {
  const ipet_tg = localStorage.getItem('ipet_tg');
  const env_ = localStorage.getItem('env');
  console.log(ipet_tg, '--->>>>>上传+',customerId)
  if (ipet_tg) {
    const sendFormData = async (formData) => {
    try {
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // 如果发送JSON数据
          // 或者如果是表单数据: 'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: JSON.stringify(formData) // 如果是JSON格式
        // 或者如果是表单数据: new URLSearchParams(formData).toString()
      };
      const url = env_ == "test"? 'https://test-asapi.ipetprints.com/shopify/userBind': 'https://asapi.ipetprints.com/shopify/userBind'; 
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log('Received data:', data); // 在这里处理返回的数据...
      localStorage.setItem('ipet_tg', '');
      localStorage.setItem('env', '');
    } catch (error) {
      console.error('Error sending data:', error);
    }
  };

    sendFormData({ urlCode: ipet_tg, customerId: customerId })
  }
}